import script from "./RelevanceBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./RelevanceBadge.vue?vue&type=script&setup=true&lang=ts"

import "./RelevanceBadge.vue?vue&type=style&index=0&id=7c6ff591&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c6ff591"]])

export default __exports__